module.exports = __webpack_public_path__ + "img/industry5.6fb50dc.jpg";